<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <!-- Pagina di login per il servizio --->
    <TsLoginPage :service_title="service_title" :service="service" :cluster="cluster" :comp_credito="comp_credito">
      <!-- Slot con info generiche prima del form -->
      <template v-slot:form-header>
        <b-row class="mt-2">
          <b-col>
            <p class="alert-message p-2"><b>ATTENZIONE!</b> Esplora attentamente tutte le possibilità di scelta offerte dalla sezione "buoni", ma ricorda che una volta inviata la richiesta d'acquisto di un prodotto/buono specifico, essa non potrà essere annullata.</p>          </b-col>
        </b-row>
      </template>
      <!-- Slot con info da porre dopo il form -->
      <template v-slot:form-footer>
        <b-row class="mt-2">
          <b-col>
            <p class="text-danger h5 text-justify">
              Il massimo spendibile in quest'area utilizzando il credito welfare, ammonta a quanto attualmente disponibile per i buoni ( art. 51c3 ) ed è pari a {{credito_buoni}} €.
            </p>
          </b-col>
        </b-row>
      </template>
    </TsLoginPage>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import TsLoginPage from '@/components/tantosvago/TsLoginPage'

export default {
  name: 'TsGiftcard',
  data () {
    return {
        // Variabili generali
        tagline_elem : [ { text : "Buoni - Giftcard", link : 'conv-giftcard' } ],

        // variabili che definiscono il servizio delle giftcard con la quale
        // configuriamo la pagina di login.
        service_title: "Buoni - Giftcard",
        service: "giftcard",
        cluster: "home",
        comp_credito: "art51c3",

        // Il credito per i buoni da poter spendere per le giftcard
        credito_buoni : this.$store.state.user.user_credito.art51c3
    }
  },
  components: {
    PageTagline,
    TsLoginPage
  }
}
</script>

<style scoped></style>